const getApiBaseUrl = () => {
    const hostname = window.location.hostname;

    if (hostname.startsWith('10.') || hostname.startsWith('192.168.') || hostname === 'localhost') {
        return 'http://10.10.1.1:5000/';
    }

    const protocol = window.location.protocol; // 'http:' или 'https:'
    return `${protocol}//cabinet.bga.gov.kg/`;
};

const getApiBaseUrlBga = () => {
    const hostname = window.location.hostname;

    if (hostname.startsWith('10.') || hostname.startsWith('192.168.') || hostname === 'localhost') {
        return 'http://10.10.1.1:5000/';
    }

    const protocol = window.location.protocol; // 'http:' или 'https:'
    return `${protocol}//cabinet.bga.gov.kg/`;
};

export const API_URL_BGA = getApiBaseUrlBga();
export const API_URL = getApiBaseUrl();
export const API_KEY_2GIS = '4a89e0a0-b65f-4495-8a60-a9c3327b63f9'
